import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import calenderimg from './images/calender-icon.png';
import { addDays } from "date-fns";
import Grid from '@mui/material/Grid';



const headCells = [
  
  { id: 'as_title', numeric: false, label: 'Assignment' },
  { id: 'sb_title', numeric: false, label: 'Subject' },
 
  { id: 'tc_title', numeric: false, label: 'Class' },
  { id: 'as_assigneddate', numeric: false, label: 'Assigned' },
  { id: 'as_duedate', numeric: false, label: 'Due' },
   { id: 'as_sort', numeric: false, label: 'Sort Order' },

  

   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});



export default class Assignment extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      assignmentdata:[],as_id:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  as_bc_batch:'',batcharray:[],as_title:'',order:'desc' ,orderBy:'',Brancharr:[],branchid:'',Classarr:[],classlabel:'Select Class', as_tc_classid:'',branchlabel:'Select Branch',searchcustomer:'',teststatus:'',
	   as_sb_id:'',subarr:[],sublabel:'Select Subject',as_branch_id:localStorage.getItem("MMCbranchid"),as_syllabustype:'', as_sort:'',     
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage);  }
	

		componentWillMount() { 
localStorage.setItem("pageactive",14)

	
	document.title = "MM Coching Center - Assignment Management";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	
  this.apicall(this.state.page,this.state.rowsPerPage);
 
}	






/*
subBind(){

    axios.get(Serverurl+'ajaxsubjects.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  subarr: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.subarr.map(sub => {
                            
          return {value: sub.sb_id, display:sub.sb_title}
        });
      
		
        this.setState({
          subarr: [{value: '', display: 'Select Subject'}].concat(roleFromApi)
        });
      })


}*/

 batchbind(){

    axios.get(Serverurl+'ajaxbatch.php?action=list&bc_class_id='+this.state.as_tc_classid+'&bc_br_id='+localStorage.getItem("MMCbranchid")+'&bc_syllabustype'+this.state.as_syllabustype)
	
    
      .then((response) => {    
     
      this.setState({  batcharray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.batcharray.map(batch => {
                            
          return {value: batch.bc_id, display:batch.bc_title}
        });
      
		
        this.setState({
          batcharray: [{value: '', display: 'Select Batch'}].concat(roleFromApi)
        });
      })


} 

ClassBind()
{
axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

} 

handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
  this.setState({
        [nam]: val
    },()=>{
		if(nam==="as_tc_classid")
		{
			//this.batchbind();
	//this.subBind();
		}else if(nam==="as_syllabustype")
		{
			//this.batchbind();
			this.ClassBind();
	
		}	
		
		
	});
 
}

apicall(page,rowsPerPage){
	
	/*let strbranch=this.state.branchid;
	 if(localStorage.getItem("MMCrole")!=="1")
	 
		  { 
			  strbranch=localStorage.getItem("MMCbranchid");
		  }*/
	 axios.get(Serverurl+'ajaxassignment.php?action=getall&as_title='+this.state.as_title+'&as_tc_classid='+this.state.as_tc_classid+'&as_sb_id='+this.state.as_sb_id+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&as_branch_id='+localStorage.getItem("MMCbranchid")+'&as_syllabustype='+this.state.as_syllabustype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  assignmentdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({assignmentdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{
		  this.apicall(this.state.page,this.state.rowsPerPage);
		
	});
   
 

  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

 
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{    this.apicall(this.state.page,this.state.rowsPerPage);}); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


assigntDelete(as_id){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('as_id',as_id)	 	   
formData.append('userid',localStorage.getItem("MMCuserid"))	
	
	
	 axios.post(Serverurl+"ajaxassignment.php", formData, {
        }).then(res => {
     this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });
 }
      }
	  
      Assignaddbox(val){
        this.setState({ as_id: val });  
  
         setTimeout(() => this.refs.AddAssigntBox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Assignment</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p> <span className="validation">*</span> Assignment</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.as_title}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Assignment Name"
            name="as_title" onChange={this.myChangeHandler}
		
          /></p></li>
		  
		  
		  {/*
		  {localStorage.getItem("MMCrole")==="1" && (<React.Fragment>
			<li><p> <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branchid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.Brancharr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl>
		
				</p>
	
</li></React.Fragment> )}*/}
	
	<li>	
	<p> <span className="validation">*</span> Syllabus</p>
	<p>
		<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.as_syllabustype}
		onChange={this.myChangeHandler}
		name='as_syllabustype'
		id='as_syllabustype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Syllabus</option>
		<option value={1}>CBSE</option>
		<option value={2}>State</option><option value={3}>PUC</option>			
		</Select>
		</FormControl>
	</p>
	</li>	
		  
	<li>
	<p> <span className="validation">*</span>Class</p>
	 <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.as_tc_classid}}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.as_tc_classid}
		  name="as_tc_classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	</li>
	
	
	
	<li><p>&nbsp;</p>
	<p >
		<Button variant="contained" className="frmsecondarybtn" onClick={this.handleClickSearch}  endIcon={<SearchIcon />}>
        Search
      </Button>	</p>
	</li>

	{/*
	<li>
	 <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.sublabel, value: this.state.as_sb_id }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.as_sb_id}
		  name="as_sb_id"
		
		
        >
		{this.state.subarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
</li>*/}
	
	
	
		</ul>
		<div className="searchnewbtn">
		
	  <p className="addnewbtn"><Button variant="contained" onClick={()=>{this.Assignaddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button></p>
	  
		</div>	
		
		
		
		
		
</div>		



<AddAssigntBox ref="AddAssigntBox" id={this.state.as_id}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.assignmentdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.assignmentdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.as_title}</TableCell>
<TableCell>{item.sb_title}</TableCell>

<TableCell>{item.tc_title}</TableCell>

<TableCell>{formatDate(item.as_assigneddate)}</TableCell>
<TableCell>{formatDate(item.as_duedate)}</TableCell>
<TableCell>{item.as_sort}</TableCell>



<TableCell align="left">
<div className="actionbtns">

<React.Fragment>
<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Assignaddbox(item.as_id)}} endIcon={<EditIcon />}>
Edit
</Button></React.Fragment>


<React.Fragment>

<Button variant="contained" className="admsndisablebtn" onClick={()=>{this.assigntDelete(item.as_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button></React.Fragment>




 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="3">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}


export  class  AddAssigntBox extends Component {

   constructor(props) {
      super(props)
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	  
      this.state = {
		  
		as_id:'',
	  as_title:'', 
      sb_title:'', 
	  bc_title:'', 
      tc_title:'', filteredSubjectArray: [],
  filteredBatchArray: [],branchid:'',as_branch_id:localStorage.getItem("MMCbranchid"),
      assigneddate:Date.now(),  as_syllabustype:'',
     duedate:Date.now(),batchlabel:'Select batch',as_bc_batch:'',open:false,testname:'',as_id:0,Brancharr:[],branch:'0',Classarr:[],as_tc_classid:'0',classlabel:'Select Class',batcharray:[],batch:'',rolelabel:'Select Batch',maxmarks:'',errormessage:'',erropen:false,te_sortorder:'',testyear:'',as_sb_id:'',subarr:[],sublabel:'Select Subject',
	  duedate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),assigneddate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),as_sort:'',
	  }
      
  }
  

  
  
  handleassignedDateChange = (date) => {
	
	  var month="",month1="";
	 var strdate=new Date(date);
strdate.setDate(strdate.getDate() + 2);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
	  if((strdate.getMonth() + 1)<10)
	 {
		month1="0"+ (strdate.getMonth() + 1)		 
	 }else{month1=(strdate.getMonth() + 1)} 
     this.setState({ assigneddate:date,
assigneddate1:date.getFullYear() + '-' + month + '-' +date.getDate(),

duedate:strdate,
duedate1:strdate.getFullYear() + '-' + month1 + '-' +strdate.getDate()
	 })
	
	
  }
  handledueDateChange = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ duedate:date,
duedate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  


  
 Assigntgetdata() {
	 	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxassignment.php?action=getall&as_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      as_id:resp.data[0].as_id,
	  as_title: resp.data[0].as_title,
      as_sb_id: resp.data[0].as_sb_id, 
	  as_bc_batch:resp.data[0].as_bc_batch, 
      as_tc_classid:resp.data[0].as_tc_classid, 
      assigneddate1: resp.data[0].as_assigneddate,  
      duedate1: resp.data[0].as_duedate,
as_syllabustype: resp.data[0].as_syllabustype || '', 
  	  
	  branchid: resp.data[0].branchid, 
	  as_branch_id: resp.data[0].as_branch_id,  
	  as_sort: resp.data[0].as_sort,  
      
	  
	  
	  
    });
	//this.batchbind();
	this.subBind();

	
	//this.ClassBind();
  }
  
});
	  
  }else{
	 this.setState({  
	  as_title:'',	 
	 sb_title:'',
	as_id:0,
	 batch:'',as_sort:''
	 
	  }); 
 }
  
    }
	
	
	
	

  ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		this.Assigntgetdata();
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}

        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })
	  
	  

} 
subBind(){

    axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.as_tc_classid+'&sb_syllabustype='+this.state.as_syllabustype)
	
    
      .then((response) => {    
     
      this.setState({  subarr: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.subarr.map(sub => {
                            
          return {value: sub.sb_id, display:sub.sb_title}
        });
      
		
        this.setState({
          subarr: [{value: '', display: 'Select Subject'}].concat(roleFromApi)
        });
      })


}

 batchbind(){

    axios.get(Serverurl+'ajaxbatch.php?action=list&bc_class_id='+this.state.as_tc_classid+'&bc_br_id='+localStorage.getItem("MMCbranchid"))
	
    
      .then((response) => {    
     
      this.setState({  batcharray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.batcharray.map(batch => {
                            
          return {value: batch.bc_id, display:batch.bc_title}
        });
      
		
        this.setState({
          batcharray: [{value: '', display: 'Select Batch'}].concat(roleFromApi)
        });
      })


}

handleClickOpen = (e) => {
	 var strdob=new Date();
	 var month="";
  if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
  this.setState({open:!this.state.open,Brancharr:[], as_syllabustype:'',branch:'0', testname:'',maxmarks:'',batcharray:[],batch:'',as_tc_classid:'', as_sb_id:'',as_bc_batch:'',
     errormessage:'',erropen:false,assigneddate: new Date(),assigneddate1:'',duedate:'', duedate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),assigndate:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),branchid:'',as_sort:'',
  dueDate: new Date(),
	  });this.ClassBind();
	  //this.subBind();
		//this.batchbind();
		//this.BranchBind();
		


};

myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;

  if (nam === "as_sort" && val !== '' && !re.test(val)) {
    return;
  }

  this.setState({ [nam]: val }, () => {
    if (nam === "as_tc_classid") {
      this.batchbind();
    } else if (nam === "as_syllabustype") {
      this.subBind();
      // this.batchbind();
    }
  });
};





 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let as_title = this.state.as_title;
 let as_sb_id = this.state.as_sb_id;
  let assigndate = this.state.assigneddate1;
   let duedate = this.state.duedate1;
   let as_bc_batch = this.state.as_bc_batch;
   let as_tc_classid = this.state.as_tc_classid;
   let branch = this.state.branch;
   let as_syllabustype = this.state.as_syllabustype;
   let as_sort = this.state.as_sort;
   


if(as_title==="")
{
	
	this.setState({errormessage:"Please Enter Assignment Name",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(as_tc_classid==="")
{
	
	this.setState({errormessage:"Please Select Class",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(as_syllabustype==="")
{
	
	this.setState({errormessage:"Please Select Syllabus Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(as_sb_id==="")
{
	
	this.setState({errormessage:"Please Select Subject",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}



if(assigndate==="")
{
	
	this.setState({errormessage:"Please Enter Assigned Date",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(duedate==="")
{
	
	this.setState({errormessage:"Please Enter Due Date",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(as_sort==="")
{
	
	this.setState({errormessage:"Please Enter Sort Order",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


   var formData = new FormData();
  
  
   if(this.state.as_id===0)
	  {
		  formData.append('as_id',0) 
		 
	  }
	  else
	  {
		  
	   formData.append('as_id',this.state.as_id)

          }
	   

        formData.append('action','insertorupdate') 
		
		formData.append('as_title',as_title)
		formData.append('as_sb_id',as_sb_id)
		formData.append('as_bc_batch',0)
		formData.append('as_tc_classid',as_tc_classid)
		formData.append('as_assigneddate',assigndate)
		formData.append('as_duedate',duedate)
		
		formData.append('as_syllabustype',as_syllabustype)
		formData.append('as_sort',as_sort)
		
		formData.append('userid',localStorage.getItem("MMCuserid"))
		
		formData.append('as_branch_id',localStorage.getItem("MMCbranchid"))
		  	
		
		  //console.log("Form data", formData); 
		axios.post(Serverurl+"ajaxassignment.php", formData, {
        }).then(res => {
    
	//console.log(res.data);
	
	if(res.data === -1)
{ 
	 
	
		this.setState({errormessage:"Assignment Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

   	

render (){

return(
<React.Fragment>




    <Dialog open={this.state.open} maxWidth="xs" fullWidth="true" onClose={this.handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Assignment Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
	
						  
	<p> <span className="validation">*</span> Assignment</p>
	
	<p><TextField
    name="as_title"
    onChange={this.myChangeHandler}  
    fullWidth
    value={this.state.as_title}     
    size="small"
    inputProps={{ tabIndex: "1", maxLength: 150 }} 
    InputLabelProps={{ shrink: true }}
/></p>
	
	
	
	
	  <p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.as_tc_classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.as_tc_classid}
		  name="as_tc_classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
  <p><span className="validation">*</span>Syllabus</p>
	
	<p>
		<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.as_syllabustype}
		onChange={this.myChangeHandler}
		name='as_syllabustype'
		id='as_syllabustype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Syllabus</option>
		<option value={1}>CBSE</option>
		<option value={2}>State</option><option value={3}>PUC</option>			
		</Select>
		</FormControl>
	</p>
	
	 <p><span className="validation">*</span>Subject</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.sublabel, value: this.state.as_sb_id }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.as_sb_id}
		  name="as_sb_id"
		
		
        >
		{this.state.subarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
 
	
 
 
 
<p><span className="validation">*</span>Assigned Date</p>
<MuiPickersUtilsProvider utils={DateFnsUtils} className="datepickermarginremove">
  <Grid container justify="space-around">
    <DatePicker
      fullWidth
      value={this.state.assigneddate1 || Date.now()}
      onChange={this.handleassignedDateChange}
      variant="inline"
      inputVariant="outlined"
      margin="normal"
      format="dd/MM/yyyy"
      autoOk 
      name="assigneddate1"
      ampm={false}
    />
  </Grid>
</MuiPickersUtilsProvider>

<p><span className="validation">*</span>Due Date</p>
<MuiPickersUtilsProvider utils={DateFnsUtils} className="datepickermarginremove">
  <Grid container justify="space-around">
    <DatePicker
      fullWidth minDate={this.state.assigneddate1}
      value={this.state.duedate1 || Date.now()}
      onChange={this.handledueDateChange}
      variant="inline"
      inputVariant="outlined"
      margin="normal"
      format="dd/MM/yyyy"
      autoOk 
      name="duedate1"
      ampm={false}
    />
  </Grid>
</MuiPickersUtilsProvider>



<p><span className="validation">*</span> Sort Order</p>

 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.as_sort}
           inputProps={{tabIndex: "1",maxLength:150}}
		
            name="as_sort" onChange={this.myChangeHandler}
		
          /></p>


       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
</DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  